import(/* webpackMode: "eager" */ "/Users/kapil/Desktop/git/zeawebsitev2/emergeweb/src/app/beer-bottle/page.tsx");
